
import { Link } from "react-router-dom";
import "./style.css"
import Carousel from 'react-bootstrap/Carousel';

const MainSlider = () => {

  const images = [
    {
      id: 1,
      src: "https://pianolangpic.s3.us-east-2.amazonaws.com/main_ad1.png",
      alt: "First Slide"
    },
    {
      id: 2,
      src: "https://pianolangpic.s3.us-east-2.amazonaws.com/main_ad2.png",
      alt: "Second Slide"
    },
    {
      id: 3,
      src: "https://pianolangpic.s3.us-east-2.amazonaws.com/main_ad3.png",
      alt: "Third Slide"
    }
  ]
    
  return (
    <Carousel controls="true">
      {images.map((imageSlide, index) => (
          <Carousel.Item key={imageSlide.id}>
          <Link to="/">
            {/* Fixed-ratio wrapper reserves space before the S3 image loads so the
                banner never snaps to height and shoves content down (CLS fix). */}
            <div className="hero-slide">
              <img
                src={imageSlide.src}
                className="hero-slide-img"
                width="1366"
                height="768"
                alt={imageSlide.alt}
                loading={index === 0 ? "eager" : "lazy"}
                fetchpriority={index === 0 ? "high" : "auto"}
              />
            </div>
          </Link>
          </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default MainSlider;
